import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import { colors, layout } from '../design-system/tokens';

/** 대시보드 지표 카드 — 운영 지표를 빠르게 비교하기 위한 compact 카드 */
const StatCard = ({ label, value, caption }) => (
  <Paper role="group" aria-label={label} sx={{ flex: 1, minWidth: 190, overflow: 'hidden' }}>
    <Box
      sx={{
        px: 2,
        py: 1,
        bgcolor: colors.canvas.subtle,
        borderBottom: `1px solid ${colors.border.subtle}`,
      }}
    >
      <Typography variant="caption" sx={{ color: colors.text.muted, fontWeight: 700 }}>
        {label}
      </Typography>
    </Box>
    <Box sx={{ p: layout.cardPadding }}>
      <Typography variant="h4" sx={{ fontSize: 26 }}>
        {value}
      </Typography>
      {caption && (
        <Box sx={{ mt: 0.75 }}>
          <Typography variant="caption" sx={{ color: colors.text.muted }}>
            {caption}
          </Typography>
        </Box>
      )}
    </Box>
  </Paper>
);

export default StatCard;
